module.exports = __webpack_public_path__ + "img/sp3.052775a8.svg";